import { createBlueprint as e } from "@made-people/blueprint";
const r = e({
  slots: {
    termsAndConditionsWrapper: "flex flex-row gap-2 items-center",
    termsAndConditionsBody: "[&>span>p>a]:underline [&>span>p>a]:underline-offset-2 text-[var(--color-foreground)]",
    checkbox: "flex h-4 w-4 items-center justify-center bg-white rounded-sm bg-[var(--color-background)]",
    checkboxIndicator: "stroke-black stroke-[var(--color-foreground)]"
  },
  variants: {}
}), t = e({
  slots: {
    inputWrapper: "w-full h-full relative flex flex-row items-center text-black",
    inputLabel: "absolute h-full w-full capitalize text-text-less-emphasis-2",
    inputField: "px-4 py-3 w-full placeholder:text-text-less-emphasis-2 border-none focus:outline-none border-transparent",
    inputError: "text-xs text-red-600 absolute -bottom-5 left-4"
  },
  variants: {
    label: {
      floating: {
        inputLabel: "leading-none start-4 duration-300 transform -translate-y-4 scale-75 top-4 origin-[0] peer-focus:text-system-info peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4",
        inputField: ""
      }
    }
  }
}), s = e({
  slots: {
    wrapper: "flex flex-row gap-2 items-center",
    label: "capitalize",
    body: "[&>span>p>a]:underline [&>span>p>a]:underline-offset-2",
    checkbox: "flex h-4 w-4 items-center justify-center bg-white rounded-sm",
    checkboxIndicator: "stroke-black"
  },
  variants: {}
}), i = e({
  slots: {
    base: "max-w-[700px] h-[240px] bg-black text-white flex flex-col py-8 px-6 gap-4 rounded-2xl",
    heading: "text-heading-sm capitalize",
    body: "",
    form: "flex flex-col gap-2",
    inputWrapper: "relative flex flex-row items-center text-black",
    buttonWrapper: "flex justify-center bg-white rounded-r-lg h-[48px]"
  },
  variants: {}
}), p = e({
  slots: {
    wrapper: "flex flex-row gap-2 items-center",
    body: "[&>span>p>a]:underline [&>span>p>a]:underline-offset-2",
    icon: "flex h-4 w-4 items-center justify-center bg-white rounded-sm"
  },
  variants: {}
}), l = e({
  slots: {
    background: "bg-black",
    wrapper: "text-white py-4",
    container: "flex flex-col gap-4 lg:flex-row justify-between",
    headingWrapper: "flex items-center justify-center",
    heading: "text-heading-sm capitalize -indent-12 pl-12 -rotate-3 text-balance max-w-[200px] [&>span]:bg-red-500",
    body: "",
    formWrapper: "lg:w-1/2",
    form: "flex flex-col gap-2",
    fieldsWrapper: "relative flex flex-row items-center text-black",
    buttonWrapper: "flex justify-center bg-white rounded-r-lg h-[48px]",
    successText: ""
  },
  variants: {}
}), c = {
  main: l,
  inputField: t,
  termsAndConditions: r
}, o = e({
  slots: {
    background: "",
    wrapper: "overflow-hidden grid grid-cols-subgrid col-span-12 px-4 lg:px-0 pt-12 lg:py-0",
    container: "grid grid-cols-subgrid col-span-12 place-items-center lg:gap-[unset]",
    headingWrapper: "flex flex-col items-start gap-3 justify-center col-span-12 lg:col-span-6 w-full mb-5 lg:mb-0",
    heading: "text-heading-md lg:text-heading-lg text-balance",
    body: "text-body-xs lg:text-body-sm font-bold lg:font-bold",
    formWrapper: "block col-span-12 lg:col-span-6 w-full ",
    form: "flex flex-col gap-4",
    fieldsWrapper: "relative flex flex-row items-center text-black bg-white rounded",
    buttonWrapper: "flex justify-center bg-transparent",
    image: "hidden",
    badge: "",
    successText: ""
  },
  variants: {
    theme: {
      primary: {
        wrapper: "[--color-foreground:white] [--color-background:black]"
      },
      secondary: {
        wrapper: "[--color-foreground:blue] [--color-background:green]"
      },
      tertiary: {
        wrapper: "[--color-foreground:blue] [--color-background:green]"
      },
      black: {
        wrapper: "[--color-foreground:blue] [--color-background:green]"
      },
      white: {
        wrapper: "[--color-foreground:blue] [--color-background:green]"
      }
    }
  }
}), d = {
  main: o,
  inputField: t,
  termsAndConditions: r
}, n = e({
  slots: {
    background: "",
    wrapper: "overflow-hidden grid grid-cols-subgrid col-span-12 px-4 lg:px-0 pt-12 lg:py-0",
    container: "grid grid-cols-subgrid col-span-12 place-items-center lg:gap-[unset]",
    headingWrapper: "flex flex-col items-start gap-3 justify-center col-span-12 lg:col-span-6 w-full mb-5 lg:mb-0",
    heading: "text-heading-md lg:text-heading-lg text-balance",
    body: "text-body-xs lg:text-body-sm font-bold lg:font-bold",
    formWrapper: "block col-span-12 lg:col-span-6 w-full ",
    form: "flex flex-col gap-4",
    fieldsWrapper: "relative flex flex-row items-center text-black bg-white rounded",
    buttonWrapper: "flex justify-center bg-transparent",
    image: "hidden",
    badge: "",
    successText: ""
  },
  variants: {
    theme: {
      primary: {
        wrapper: "[--color-foreground:white] [--color-background:black]"
      },
      secondary: {
        wrapper: "[--color-foreground:blue] [--color-background:green]"
      },
      tertiary: {
        wrapper: "[--color-foreground:blue] [--color-background:green]"
      },
      black: {
        wrapper: "[--color-foreground:blue] [--color-background:green]"
      },
      white: {
        wrapper: "[--color-foreground:blue] [--color-background:green]"
      }
    }
  }
}), g = {
  main: n,
  inputField: t,
  termsAndConditions: r
};
export {
  p as errorStyling,
  t as inputFieldStyling,
  i as newsletterTemplate1Styling,
  l as newsletterTemplate2,
  c as newsletterTemplate2Styling,
  o as newsletterTemplate3,
  d as newsletterTemplate3Styling,
  n as newsletterTemplate4,
  g as newsletterTemplate4Styling,
  s as signupListsStyling,
  r as termsAndConditionsStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
